module.exports = __webpack_public_path__ + "static/media/ZonaVerde.b120c02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/ZonaVerde.png
// module id = 75
// module chunks = 0